module.exports = __webpack_public_path__ + "static/media/vgu-login-banner3.da5434cf.jpg";